import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { User } from "@typings/entities/users";

async function getUserById(id: string): Promise<User> {
  const response = await apiClient.get<User>(apiPaths.users.getById(id));
  return response.data;
}

export function useGetUserById(
  userId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    userId ? `fetch-user-${userId}` : null,
    () => getUserById(userId!),
    options,
  );
}
